module.exports = __webpack_public_path__ + "43cf27ede2b100966f6b07089460ca24.svg";